import './sky-hero-slider.scss';

document.addEventListener('DOMContentLoaded', function () {
    // Pre-initialize all slider components by getting references
    const sliders = document.querySelectorAll('.sky-hero-slider');
    if (!sliders.length) return;

    // Function to initialize sliders with a slight delay to ensure all elements are properly rendered
    const initializeSliders = () => {
        sliders.forEach(slider => {
            // Skip already initialized sliders
            if (slider.classList.contains('initialized')) return;

            const swiperContainer = slider.querySelector('.swiper-container');
            if (!swiperContainer) return;

            // Get configuration from data attributes
            const speed = parseInt(slider.dataset.speed) || 5000;
            const pauseOnHover = slider.dataset.pauseOnHover === 'true';

            // Initialize Swiper with optimized settings
            const heroSlider = new Swiper(swiperContainer, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                updateOnImagesReady: true,
                watchSlidesProgress: true,
                autoplay: {
                    delay: speed,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: slider.querySelector('.swiper-pagination'),
                    type: 'bullets',
                    clickable: true,
                },
                on: {
                    init: function () {
                        // Mark as initialized
                        slider.classList.add('initialized');
                    }
                }
            });

            // Add pause on hover functionality if enabled
            if (pauseOnHover) {
                swiperContainer.addEventListener('mouseenter', () => {
                    heroSlider.autoplay.stop();
                });
                swiperContainer.addEventListener('mouseleave', () => {
                    heroSlider.autoplay.start();
                });
            }
        });
    };

    // Initialize with a very short delay to ensure DOM is fully processed
    if (document.readyState === 'complete') {
        initializeSliders();
    } else {
        // Use requestAnimationFrame for smoother initialization
        requestAnimationFrame(initializeSliders);
    }
});